module.exports = __webpack_public_path__ + "assets/img/step8-1.e2544327.png";